// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3k_0l","colMaxWidth":"Table_colMaxWidth__1vbY8"};